import { useEffect, useState } from 'react'
import {
    safeLocalStorageGet,
    safeLocalStorageSet
} from '@lib/utils/safeLocalStorage'
import { PLP_CONFIG } from '@pylot/constants/plp'

const GRID_COLUMNS_STORAGE_KEY = 'plp-grid-columns'

function parseStoredGridColumns(stored: string): 4 | 7 | null {
    if (stored === '4' || stored === '7') return Number(stored) as 4 | 7
    return null
}

export const usePLPGridColumns = () => {
    const [gridColumns, setGridColumns] = useState<4 | 7>(
        PLP_CONFIG.DEFAULT_GRID_COLUMNS
    )
    const [isGridReflowing, setIsGridReflowing] = useState(false)

    useEffect(() => {
        const stored = safeLocalStorageGet(
            GRID_COLUMNS_STORAGE_KEY,
            parseStoredGridColumns,
            PLP_CONFIG.DEFAULT_GRID_COLUMNS
        )
        setGridColumns(stored)
    }, [])

    useEffect(() => {
        safeLocalStorageSet(GRID_COLUMNS_STORAGE_KEY, String(gridColumns))
    }, [gridColumns])

    useEffect(() => {
        const timer = setTimeout(
            () => setIsGridReflowing(false),
            PLP_CONFIG.GRID_REFLOW_TIMEOUT
        )
        setIsGridReflowing(true)
        return () => clearTimeout(timer)
    }, [gridColumns])

    return { gridColumns, setGridColumns, isGridReflowing }
}
